import * as actions from "../constants/actionTypes";

const initialState = {
    cargo: null,
    cargo_port: null,
    client: null,
    client_contact: null,
    client_rate: null,
    commodity: null,
    commodity_group: null,
    company: null,
    company_contact: null,
    configuration: null,
    cost: null,
    cost_line: null,
    country: null,
    currency: null,
    fog: null,
    invoice: null,
    invoice_line: null,
    port: null,
    role: null,
    service: null,
    underwriter_rate: null,
    user: null,
    vessel: null,

    editing: false,
};

export default function edit(state = initialState, action) {
    let newState = Object.assign({}, state);

    switch (action.type) {
        /**
         * DONE EDITING
         */
        case actions.DONE_EDITING_CARGO_PORT:
            newState.cargo_port = null;
            newState.editing = false;
            break;
        case actions.DONE_EDITING_CLIENT_RATE:
            newState.client_rate = null;
            newState.editing = false;
            break;
        case actions.DONE_EDITING_COMMODITY:
            newState.commodity = null;
            newState.editing = false;
            break;
        case actions.DONE_EDITING_COMMODITY_GROUP:
            newState.commodity_group = null;
            newState.editing = false;
            break;
        case actions.DONE_EDITING_CONFIGURATION:
            newState.configuration = null;
            newState.editing = false;
            break;
        case actions.DONE_EDITING_COST:
            newState.cost = null;
            newState.editing = false;
            break;
        case actions.DONE_EDITING_COST_LINE:
            newState.cost_line = null;
            newState.editing = false;
            break;
        case actions.DONE_EDITING_INVOICE:
            newState.invoice = null;
            newState.editing = false;
            break;
        case actions.DONE_EDITING_INVOICE_LINE:
            newState.invoice_line = null;
            newState.editing = false;
            break;
        case actions.DONE_EDITING_PORT:
            newState.port = null;
            newState.editing = false;
            break;
        case actions.DONE_EDITING_ROLE:
            newState.role = null;
            newState.editing = false;
            break;
        case actions.DONE_EDITING_SERVICE:
            newState.service = null;
            newState.editing = false;
            break;
        case actions.DONE_EDITING_UNDERWRITER_RATE:
            newState.underwriter_rate = null;
            newState.editing = false;
            break;
        case actions.DONE_EDITING_USER:
            newState.user = null;
            newState.editing = false;
            break;

        default: break;
    }
    return newState;
}



// WEBPACK FOOTER //
// ./src/reducers/edit.js